module.exports = __webpack_public_path__ + "img/sankaku_16_red.d7b5e6f0.png";